export default __webpack_public_path__ + "static/media/footer-wave.c7856c17.svg";